var BundleVariantEnum = /*#__PURE__*/function (BundleVariantEnum) {
  BundleVariantEnum["VariantA"] = "BundleVariantA";
  BundleVariantEnum["VariantB"] = "BundleVariantB";
  BundleVariantEnum["VariantC"] = "BundleVariantC";
  return BundleVariantEnum;
}({});

export { BundleVariantEnum };
